<script setup lang="ts">
import type { defaultSideItemProps } from '@/types/appTypes'

const props = withDefaults(defineProps<defaultSideItemProps>(), {})

const app = useNuxtApp()
const storeIndex = useStoreIndex()
const storeUser = useStoreUser()

const onClickDetail = () => {
  const to = `/present/${props.item.article_slug}`
  if (storeUser.state.isLogin) {
    navigateTo(to)
  } else {
    storeUser.setLoginRedirectPath(to)
    navigateTo('/login')
  }
}
</script>

<template>
  <div class="c-presentSideItem">
    <div
      class="c-presentSideItem_image"
      v-on:click="onClickDetail()"
    >
      <CommonImage
        v-bind:src="storeIndex.getArticleEyeCatchImageURL(item.eye_catch_image_object, 's')"
        error-src="/images/noimage.svg"
        v-bind:alt="item.title"
        object-fit="cover"
        is-hover-effect
        height="155"
      />
    </div>
    <div class="c-presentSideItem_data">
      <div class="c-presentSideItem_data_eventPlace" />
      <nuxt-link
        class="c-presentSideItem_data_eventName c-clampLines is-clampline5"
        v-bind:to="'/present/${props.item.articleSlug}'"
      >
        {{ item.title }}
      </nuxt-link>
      <div class="c-presentSideItem_data_deadline" />
      <div
        class="c-presentSideItem_data_apply"
        v-on:click="onClickDetail()"
      >
        <v-icon class="c-presentSideItem_data_apply_icon">
          mdi-chevron-right
        </v-icon>
        <div
          class="c-presentSideItem_data_apply_text"
        >
          応募する
        </div>
      </div>
    </div>
  </div>
</template>

<style lang = "scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

@keyframes underLineNormal {
  from {
    left: 7px;
    width: calc(100% - 10px);
  }

  to {
    left: calc(100% - 3px);
    width: 0;
  }
}

@keyframes underLineHover {
  from {
    left: 7px;
    width: 0;
  }

  to {
    left: 7px;
    width: calc(100% - 10px);
  }
}

.c-presentSideItem {
  display: flex;
  margin-top: 15px;
  margin-bottom: 10px;

  &_image {
    flex-shrink: 0;
    width: 110px;
    cursor: pointer;
  }

  &_data {
    flex-grow: 1;
    padding-right: 10px;

    &_eventPlace {
      margin-top: 1px;
      margin-left: 10px;
      color: var(--color_text_lightgray);
      font-size: 12px;
      font-weight: bold;
    }

    &_eventName {
      margin-top: 5px;
      margin-left: 10px;
      color: var(--color_text_base);
      font-size: 14px;
      font-weight: bold;
    }

    &_deadline {
      margin-top: 10px;
      margin-left: 10px;
      color: var(--g_color_text_c20000);
      font-family: var(--g_font_family_NotoSansCJKjp);
      font-size: 12px;
    }

    &_apply {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 7px;
      margin-left: 5px;
      cursor: pointer;

      &_icon {
        color: var(--color_primary_link);
        font-weight: bold;
      }

      &_text {
        color: var(--color_primary_link);
        font-size: 14px;
        font-weight: bold;
        line-height: 2.286;
      }

      &:hover & {
        &_text {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
